// extracted by mini-css-extract-plugin
export default {"loaderContainer":"Loader_loaderContainer__mhZN2","loadingText":"Loader_loadingText__p26Wb","loader":"Loader_loader__q63Mv","loaderSpin":"Loader_loaderSpin__1JBVn"};